import './Header.scss';

import LogoImage from 'assets/images/logo.jpg';
import HeaderMenu from 'components/header/HeaderMenu';
import { MobileHeaderMenu } from 'components/header/mobileHeaderMenu';
import Image from 'components/image';
import { FC, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { genImageAltText } from 'utils/genImageAltText';

const Header: FC = () => {
  const headerContainerRef = useRef<HTMLElement>(null);
  const [headerMenuTop, setHeaderMenuTop] = useState<number>(0);
  const [isStickyHeader, setIsStickyHeader] = useState<boolean>(false);

  useEffect(() => {
    const handleSetHeaderMenuTopSpace = () => setHeaderMenuTop(headerContainerRef?.current?.offsetHeight || 0);

    window.addEventListener('resize', handleSetHeaderMenuTopSpace);

    handleSetHeaderMenuTopSpace();

    return () => window.removeEventListener('resize', handleSetHeaderMenuTopSpace);
  }, [headerContainerRef]);

  useEffect(() => {
    const handleSetHeaderType = () => {
      const windowScrollTop = window.scrollY || 0;

      if (windowScrollTop >= headerMenuTop) setIsStickyHeader(true);
      else if (windowScrollTop === 0) setIsStickyHeader(false);
    };

    window.addEventListener('scroll', handleSetHeaderType);

    handleSetHeaderType();

    return () => window.removeEventListener('scroll', handleSetHeaderType);
  }, [headerMenuTop]);

  return (
    <nav
      id='header-container'
      ref={headerContainerRef}
      className={[
        'left-0 px-2 sm:px-4 py-5 w-full z-50 shadow-[0_2px_5px_-2px_#0000001a] nav-link__container header-container',
        isStickyHeader ? 'bg-white header-container__sticky' : 'static'
      ].join(' ')}
    >
      <div className='container flex flex-wrap items-center mx-auto relative flex-row-reverse lg:flex-row'>
        <div className='flex items-center justify-center flex-1 lg:mr-3 lg:flex-[unset] '>
          <Link to={'/'} className='block w-9 sm:w-16'>
            <i className='pb-100% relative w-full block'>
              <Image src={LogoImage} className='absolute w-full h-full left-0 top-0 object-cover' alt={genImageAltText('Logo')} />
            </i>
          </Link>
        </div>

        <MobileHeaderMenu />

        <div className='w-full justify-center items-center flex-1 bg-white hidden lg:bg-transparent lg:flex lg:w-auto lg:order-1'>
          <HeaderMenu />
        </div>
      </div>
    </nav>
  );
};

export default Header;
